import { hasPermission } from '../utils/session';

export const PERMISSION_READ = 'P001';
export const PERMISSION_CREATE = 'P002';
export const PERMISSION_UPDATE = 'P003';
export const PERMISSION_SYSTEM_EDIT = 'P005';

export function canRead() {
  return hasPermission(PERMISSION_READ);
}

export function canCreateRecord() {
  return hasPermission(PERMISSION_CREATE);
}

export function canUpdateRecord() {
  return hasPermission(PERMISSION_UPDATE);
}

export function canRecordDeadChicken() {
  return canCreateRecord() || canUpdateRecord();
}

export function canManageUsers() {
  return hasPermission(PERMISSION_SYSTEM_EDIT);
}
